import { useDefaultModulesList } from "@/entities/module";

export const useDefaultModulesSelectOptionValues = () => {
  const { modules: defaultModules, isLoading } = useDefaultModulesList();

  return {
    isLoading,
    defaultModulesSelectValues: defaultModules?.map((module) => ({
      value: module.id,
      label: module.name,
      key: module.id,
    })),
  };
};
